import React, { useState, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper } from '@mui/material';
import { PageTitleContainer } from '../components/common';

// Tile component for the landing page
const SettingsTile = ({ label, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      py: 4,
      px: 3,
      cursor: 'pointer',
      borderBottom: '1px solid #c2c0c0ff',
      '&:hover': { bgcolor: '#f9f9f9' },
      fontSize: 16,
      color: '#333',
    }}
  >
    {label}
  </Box>
);

const UserPermissionLanding = () => {
  const navigate = useNavigate();
  // State for content height
  const [contentHeight, setContentHeight] = useState('calc(100vh - 130px)');
  // Calculate content height based on window size and header heights
  useLayoutEffect(() => {
    const updateContentHeight = () => {
      // Default header heights (fallback values if refs aren't available)
      const mainHeaderHeight = 73;  // Main app header
      const titleHeaderHeight = 80; // Create project header
      const extraPadding = 69;      // Additional padding for spacing

      const totalHeaderHeight = mainHeaderHeight + titleHeaderHeight + extraPadding;
      setContentHeight(`calc(100vh - ${totalHeaderHeight}px)`);
    };

    // Initial calculation
    updateContentHeight();

    // Re-calculate on window resize
    window.addEventListener('resize', updateContentHeight);

    return () => {
      window.removeEventListener('resize', updateContentHeight);
    };
  }, []);
  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: '#f5f6f7',
        minHeight: '100vh',
        pb: 4,
        px: 6,
        pt: 4,
        overflowX: 'hidden',
        backgroundImage: 'none', // Explicitly remove any background image
        '&::before': { display: 'none' },
        '&::after': { display: 'none' }
      }}
    >
      <PageTitleContainer
        title="User Permission"
        sx={{
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          ml: 0,
          mr: 0,
          mb: 2,
          mt: 0,
          py: '16px' // Exact 16px padding top and bottom
        }}
        titleProps={{
          sx: { fontFamily: "'Sofia Pro Bold', 'Sofia Pro', sans-serif", fontWeight: 700 }
        }}
      />
      <Paper sx={{
        borderRadius: '4px',
        p: { xs: 2, sm: "12px 0px 12px 12px" },
        width: '100%',
        height: contentHeight,
        bgcolor: 'white',
        overflowX: 'hidden',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        backgroundImage: 'none',
        '&::before': {
          display: 'none'
        },
        '&::after': {
          display: 'none'
        }
      }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          <Box>
            <SettingsTile label="Create roles" onClick={() => navigate('/roles/create')} />
            <SettingsTile label="Create permissions" onClick={() => navigate('/permissions/create')} />
          </Box>
          <Box>
            <SettingsTile label="Manage roles" onClick={() => navigate('/roles/manage')} />
            <SettingsTile label="Manage permissions" onClick={() => navigate('/permissions/manage')} />
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserPermissionLanding;
